/* Orbe Paris — carrousel avis (auto-scroll + navigation par flèches)
   L'autoplay ne tourne QUE quand toutes ces conditions sont réunies :
   carrousel visible dans le viewport (IntersectionObserver), pas de
   prefers-reduced-motion, et aucune interaction en cours (hover, focus
   clavier dans la section, touch, ou répit après un clic de flèche).
   Dès qu'une condition tombe, la boucle rAF est ANNULÉE
   (cancelAnimationFrame) — pas de boucle qui tourne à vide, jamais
   deux boucles simultanées (id unique). Les flèches et le défilement
   manuel restent toujours disponibles, autoplay actif ou non. */
(function () {
  document.querySelectorAll('[data-orbe-carousel]').forEach(function (track) {
    var speedSec = parseFloat(track.getAttribute('data-speed')) || 30;
    var autoplayEnabled = track.getAttribute('data-autoplay') !== 'false';

    var section = track.closest('section') || document;
    var prevBtn = section.querySelector('[data-orbe-carousel-prev]');
    var nextBtn = section.querySelector('[data-orbe-carousel-next]');

    function cardStep() {
      var card = track.querySelector('.orbe-avis__card');
      if (!card) return track.clientWidth * 0.8;
      var styles = window.getComputedStyle(track.querySelector('.orbe-avis__list') || track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    // --- États (chacun suspend l'autoplay tant qu'il est vrai)
    var motionQuery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    var motionReduced = motionQuery ? motionQuery.matches : false;
    var inView = false;
    var hovering = false;
    var touching = false;
    var focused = false;
    var settleTimer = null;

    function isPaused() {
      return hovering || touching || focused || settleTimer !== null;
    }

    // Répit après une action volontaire (flèche, fin de touch) avant reprise.
    function settle(ms) {
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        settleTimer = null;
        sync();
      }, ms);
      sync();
    }

    // --- Boucle rAF : id unique, annulée proprement à l'arrêt.
    var rafId = null;
    var lastTs = null;

    function tick(ts) {
      if (lastTs == null) lastTs = ts;
      var dt = (ts - lastTs) / 1000;
      lastTs = ts;

      var max = track.scrollWidth - track.clientWidth;
      if (max > 0) {
        var pxPerSec = max / speedSec;
        var next = track.scrollLeft + pxPerSec * dt;
        if (next >= max - 1) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollLeft = next;
        }
      }
      rafId = requestAnimationFrame(tick);
    }

    function startLoop() {
      if (rafId !== null) return;
      lastTs = null;
      rafId = requestAnimationFrame(tick);
    }

    function stopLoop() {
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      lastTs = null;
    }

    function sync() {
      if (autoplayEnabled && inView && !motionReduced && !isPaused()) {
        startLoop();
      } else {
        stopLoop();
      }
    }

    // --- Navigation par flèches (toujours active, autoplay ou non)
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        settle(4000);
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        settle(4000);
        var max = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= max - 1) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: cardStep(), behavior: 'smooth' });
        }
      });
    }

    // --- Interactions utilisateur
    track.addEventListener('mouseenter', function () { hovering = true; sync(); });
    track.addEventListener('mouseleave', function () { hovering = false; sync(); });
    track.addEventListener('touchstart', function () { touching = true; sync(); }, { passive: true });
    track.addEventListener('touchend', function () { touching = false; settle(1500); }, { passive: true });
    track.addEventListener('touchcancel', function () { touching = false; settle(1500); }, { passive: true });

    // Pause tant qu'un élément de la section a le focus clavier
    // (flèches, piste tabbable…). relatedTarget = prochain élément focusé.
    section.addEventListener('focusin', function () { focused = true; sync(); });
    section.addEventListener('focusout', function (e) {
      focused = e.relatedTarget ? section.contains(e.relatedTarget) : false;
      sync();
    });

    if (motionQuery && motionQuery.addEventListener) {
      motionQuery.addEventListener('change', function (e) {
        motionReduced = e.matches;
        sync();
      });
    }

    // --- Visibilité : l'autoplay ne tourne que si le carrousel est à l'écran.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inView = entry.isIntersecting;
          sync();
        });
      }).observe(track);
    } else {
      inView = true;
      sync();
    }
  });
})();

/* Orbe Paris — socle motion : apparition au scroll (Reveal + Stagger + Trace)
   Les éléments qui entrent dans le viewport au même instant reçoivent un
   index --orbe-i (plafonné à 5) : le CSS les décale de 90 ms chacun.
   L'index est retiré après l'entrée pour ne pas retarder d'éventuelles
   transitions ultérieures sur le même élément. */
(function () {
  var targets = document.querySelectorAll('.orbe-reveal, .orbe-trace, .orbe-stagger');
  if (!targets.length) return;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion || !('IntersectionObserver' in window)) {
    targets.forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  function clearStaggerAfterEntry(el) {
    el.addEventListener('transitionend', function handler(e) {
      if (e.target !== el) return;
      el.style.removeProperty('--orbe-i');
      el.removeEventListener('transitionend', handler);
    });
  }

  var observer = new IntersectionObserver(function (entries) {
    var batch = entries
      .filter(function (entry) { return entry.isIntersecting; })
      .sort(function (a, b) {
        return (
          a.boundingClientRect.top - b.boundingClientRect.top ||
          a.boundingClientRect.left - b.boundingClientRect.left
        );
      });

    batch.forEach(function (entry, i) {
      var el = entry.target;
      // Les conteneurs .orbe-stagger gèrent leur cascade en CSS (nth-child) :
      // pas d'index de batch sur eux.
      if (i > 0 && !el.classList.contains('orbe-stagger')) {
        el.style.setProperty('--orbe-i', Math.min(i, 5));
        clearStaggerAfterEntry(el);
      }
      el.classList.add('is-visible');
      observer.unobserve(el);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  targets.forEach(function (el) {
    observer.observe(el);
  });
})();

/* Orbe Paris — scrollytelling compression (section logistique-orbe-v6)
   Bidirectionnel : une étape s'active quand elle entre dans le viewport,
   et se désactive quand on remonte AU-DESSUS d'elle (sortie par le bas
   de l'écran) — le rail se vide et le galet se recompresse, puis tout se
   rejoue à la descente. Une étape déjà dépassée (sortie par le haut)
   reste active : on ne rejoue pas l'animation dans le dos du lecteur.
   data-orbe-state = index de la plus haute étape active (0 si aucune).
   Sans IO ou en mouvement réduit : état final posé, sans transition.
   Aucun listener scroll, aucun rAF, observer permanent unique. */
(function () {
  var section = document.querySelector('[data-orbe-compression]');
  if (!section) return;
  var steps = section.querySelectorAll('[data-orbe-step]');
  if (!steps.length) return;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setFinalState() {
    steps.forEach(function (step) {
      step.classList.add('is-active');
    });
    section.setAttribute('data-orbe-state', String(steps.length));
  }

  if (reduceMotion || !('IntersectionObserver' in window)) {
    setFinalState();
    return;
  }

  function syncState() {
    var state = 0;
    steps.forEach(function (step) {
      if (step.classList.contains('is-active')) {
        var index = parseInt(step.getAttribute('data-orbe-step'), 10) || 0;
        if (index > state) state = index;
      }
    });
    section.setAttribute('data-orbe-state', String(state));
  }

  // Sur smartphone, les étapes sont hautes : on déclenche plus tôt (moins de
  // hauteur visible requise + zone de déclenchement plus basse dans l'écran).
  var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  var activateRatio = isMobile ? 0.35 : 0.5;
  var bottomMargin = isMobile ? '-5%' : '-12%';

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var step = entry.target;
      if (entry.isIntersecting && entry.intersectionRatio >= activateRatio) {
        step.classList.add('is-active');
      } else if (!entry.isIntersecting) {
        // Sortie complète par le bas du viewport = l'utilisateur est
        // remonté au-dessus de l'étape → on la désarme pour le replay.
        var rootBottom = entry.rootBounds ? entry.rootBounds.bottom : window.innerHeight;
        if (entry.boundingClientRect.top >= rootBottom) {
          step.classList.remove('is-active');
        }
      }
    });
    syncState();
  }, { threshold: [0, activateRatio], rootMargin: '0px 0px ' + bottomMargin + ' 0px' });

  steps.forEach(function (step) {
    observer.observe(step);
  });
})();

/* Orbe Paris — lookbook showroom : choix du décor (section lookbook-orbe-v5).
   Desktop uniquement (sur mobile, la galerie scroll-snap se suffit).
   Survol d'un nom = aperçu ; clic = choix (stoppe la rotation pour de bon).
   Rotation automatique douce (6 s, setInterval — pas de rAF) seulement si :
   visible (IO), pas de prefers-reduced-motion, aucune interaction en cours,
   pas de choix manuel. */
(function () {
  var root = document.querySelector('[data-orbe-lookbook]');
  if (!root) return;
  var items = root.querySelectorAll('[data-orbe-look-item]');
  var btns = root.querySelectorAll('[data-orbe-look-btn]');
  if (items.length < 2 || btns.length !== items.length) return;

  var motionQuery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktopQuery = window.matchMedia && window.matchMedia('(min-width: 1000px)');
  var current = 0;
  var chosen = false;
  var interacting = false;
  var inView = false;
  var timer = null;

  function setActive(index) {
    current = index;
    items.forEach(function (el, i) {
      el.classList.toggle('is-active', i === index);
    });
    btns.forEach(function (btn, i) {
      btn.classList.toggle('is-active', i === index);
      btn.setAttribute('aria-pressed', String(i === index));
    });
  }

  function start() {
    if (timer || chosen || interacting || !inView) return;
    if (motionQuery && motionQuery.matches) return;
    if (desktopQuery && !desktopQuery.matches) return;
    timer = setInterval(function () {
      setActive((current + 1) % items.length);
    }, 6000);
  }

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  btns.forEach(function (btn, i) {
    btn.addEventListener('click', function () {
      chosen = true;
      stop();
      setActive(i);
    });
    btn.addEventListener('mouseenter', function () {
      setActive(i);
    });
  });

  root.addEventListener('mouseenter', function () { interacting = true; stop(); });
  root.addEventListener('mouseleave', function () { interacting = false; start(); });
  root.addEventListener('focusin', function () { interacting = true; stop(); });
  root.addEventListener('focusout', function (e) {
    interacting = e.relatedTarget ? root.contains(e.relatedTarget) : false;
    if (!interacting) start();
  });

  if (motionQuery && motionQuery.addEventListener) {
    motionQuery.addEventListener('change', function (e) {
      if (e.matches) stop(); else start();
    });
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        inView = entry.isIntersecting;
        if (inView) start(); else stop();
      });
    }).observe(root);
  } else {
    inView = true;
    start();
  }
})();

/* Orbe Paris — cartes formats : détail au tap sur écran tactile.
   Sur desktop (pointeur fin), le hover/focus gère l'état actif en CSS pur ;
   ici on ne traite que les écrans sans survol. Une seule carte ouverte à
   la fois. Les clics sur le CTA (lien) ne sont jamais interceptés. */
(function () {
  var grid = document.querySelector('[data-orbe-format-grid]');
  if (!grid) return;

  grid.addEventListener('click', function (e) {
    if (e.target.closest('a')) return;
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var card = e.target.closest('[data-orbe-format-card]');
    if (!card) return;
    var wasOpen = card.classList.contains('is-open');
    grid.querySelectorAll('[data-orbe-format-card].is-open').forEach(function (c) {
      c.classList.remove('is-open');
    });
    if (!wasOpen) card.classList.add('is-open');
  });
})();

/* === Orbe : panier — animation suppression + maj badge + filet de sécurité total === */
(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    // 1. Animation suppression : actif globalement (n'affecte que les pages avec cart-remove-button).
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('cart-remove-button');
      if (!btn) return;
      var row = btn.closest('.cart-item');
      if (row) row.classList.add('orbe-removing');
    }, true);

    // 2. Filet de sécurité — n'installe le hook fetch qu'en présence du custom element cart-items
    //    (donc uniquement sur /cart). Si pas là, on n'altère pas window.fetch.
    if (!document.querySelector('cart-items')) return;

    var origFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = '';
      try { url = (typeof input === 'string') ? input : (input && input.url) || ''; } catch (e) {}
      var p = origFetch(input, init);
      if (/\/cart\/(change|update|add)(\.js)?/i.test(url)) {
        // On attend que la requête ait ABOUTI avant de relire /cart.js.
        // Un simple `setTimeout(350)` partait au moment de l'appel : quand le
        // serveur mettait plus longtemps, on relisait l'ancien panier et la
        // mensualité Klarna restait sur le montant précédent — un chiffre faux
        // sous le bouton d'achat.
        // `.then` ne CONSOMME PAS la réponse tant qu'on ne lit pas son corps
        // (pas de .json()/.text() ici) : le code appelant reçoit `p` intact.
        // Deux passes : la première après le re-rendu de Dawn, la seconde en
        // filet de sécurité si ce re-rendu a traîné.
        var planifier = function () {
          setTimeout(refreshOrbeCart, 250);
          setTimeout(refreshOrbeCart, 1200);
        };
        p.then(planifier, planifier);
      }
      return p;
    };

    // 3. Barre de commande fixe : on suit la visibilité du vrai bouton.
    //    IntersectionObserver plutôt qu'un écouteur de défilement — pas de
    //    calcul à chaque pixel parcouru. Repli sur `scroll` si indisponible.
    var realCta = document.getElementById('checkout');
    if (realCta && 'IntersectionObserver' in window) {
      new IntersectionObserver(function () { syncStickyCta(); }).observe(realCta);
    } else {
      window.addEventListener('scroll', syncStickyCta, { passive: true });
    }
    window.addEventListener('resize', syncStickyCta, { passive: true });
    syncStickyCta();
  });

  function refreshOrbeCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart) return;
        // Total estimé
        var formatted = formatMoney(cart.total_price);
        document.querySelectorAll('.totals__total-value').forEach(function (el) {
          if (el.textContent.trim() !== formatted.trim()) {
            el.textContent = formatted;
            el.classList.add('orbe-total-bump');
            setTimeout(function () { el.classList.remove('orbe-total-bump'); }, 500);
          }
        });
        // Badge header
        document.querySelectorAll('[data-orbe-cart-count]').forEach(function (el) {
          if (cart.item_count > 0) {
            el.textContent = cart.item_count;
            el.removeAttribute('hidden');
          } else {
            el.textContent = '';
            el.setAttribute('hidden', '');
          }
        });
        // États is-empty pour styles Dawn
        var ci = document.querySelector('cart-items');
        var cf = document.getElementById('main-cart-footer');
        if (ci) ci.classList.toggle('is-empty', cart.item_count === 0);
        if (cf) cf.classList.toggle('is-empty', cart.item_count === 0);

        // `body.orbe-cart-empty` pilote une SECTION entière (« La Collection »,
        // réservée au panier vide). theme.liquid ne la pose qu'au rendu serveur :
        // sans cette resynchronisation, retirer le dernier article laissait la
        // page dans un état bâtard — panier vide, mais collection toujours
        // masquée jusqu'au prochain rechargement.
        document.body.classList.toggle('orbe-cart-empty', cart.item_count === 0);

        // Mensualité Klarna : elle vit hors de `.js-contents`, le seul conteneur
        // que Dawn re-rend. Sans cette ligne, « 3 × 560 € » resterait figé après
        // un changement de quantité — un montant faux sous le bouton d'achat.
        // Arrondi au centime supérieur, comme le calcul Liquid.
        var third = Math.ceil(cart.total_price / 3);
        document.querySelectorAll('[data-orbe-klarna-third]').forEach(function (el) {
          el.textContent = formatOrbeMoney(third);
        });

        // La barre fixe vient d'être re-rendue : elle repart sans sa classe
        // d'escamotage, il faut réévaluer tout de suite si elle doit s'afficher.
        syncStickyCta();

        // Si vide, vider la zone erreur Dawn (au cas où elle aurait gardé un message)
        var errBox = document.getElementById('cart-errors');
        if (errBox) errBox.textContent = '';
      })
      .catch(function () {});
  }

  /* Barre de commande fixe (mobile) — escamotée tant que le vrai bouton
     « Finaliser ma commande » est à l'écran, pour ne pas afficher deux fois
     la même action. Recalculé à la volée plutôt que mémorisé : le conteneur
     de la barre est remplacé à chaque mise à jour du panier. */
  function syncStickyCta() {
    var bar = document.querySelector('[data-orbe-sticky-cta]');
    if (!bar) return;
    var realCta = document.getElementById('checkout');
    if (!realCta) return;
    var r = realCta.getBoundingClientRect();
    var visible = r.top < window.innerHeight && r.bottom > 0;
    bar.classList.toggle('is-hidden', visible);
  }

  /* Réplique EXACTE du snippet `orbe-money.liquid` : euros entiers, séparateur
     de milliers en espace insécable, « € » en suffixe — « 1 060 € ».
     Ne pas confondre avec `formatMoney` ci-dessous, qui produit le format long
     de Dawn (« 1 060,00 € EUR ») : l'employer ici afficherait deux écritures
     différentes du même prix sur une seule page. */
  function formatOrbeMoney(cents) {
    var euros = Math.trunc(cents / 100);
    return String(euros).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €';
  }

  function formatMoney(cents) {
    // Format français : 2 000,00 € EUR (espace insécable, virgule décimale)
    var euros = (cents / 100).toFixed(2);
    var parts = euros.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return intPart + ',' + parts[1] + ' € EUR';
  }
})();

/* === Orbe : footer légal — garantit les 4 liens sur toutes les pages (contourne cache Shopify) === */
(function () {
  function fixFooter() {
    var copyright = document.querySelector('.footer__copyright');
    if (!copyright) return;

    // 1. Supprimer les anciens <small class="copyright__content"> qui contiennent © / Shopify / powered_by
    var smalls = copyright.querySelectorAll(':scope > small.copyright__content');
    smalls.forEach(function (s) {
      var t = s.textContent || '';
      var a = s.querySelector('a');
      if (/©|copyright|propulsé|Shopify/i.test(t) || (a && /shopify\.com/.test(a.getAttribute('href') || ''))) {
        s.remove();
      }
    });

    // 2. Construire la liste des 4 liens si elle n'est pas déjà complète
    var ul = copyright.querySelector('ul.policies');
    var required = [
      { href: '/pages/politique-confidentialite', label: 'Politique de confidentialité' },
      { href: '/pages/preferences-cookies', label: 'Préférences en matière de cookies' },
      { href: '/pages/conditions-generales-de-vente', label: 'CGV' },
      { href: '/pages/mentions-legales', label: 'Mentions légales' }
    ];

    if (!ul) {
      ul = document.createElement('ul');
      ul.className = 'policies list-unstyled';
      copyright.appendChild(ul);
    }

    // 3. Retirer tout li qui pointe vers /policies/* (URLs Shopify obsolètes)
    ul.querySelectorAll('li').forEach(function (li) {
      var a = li.querySelector('a');
      if (a && /\/policies\//.test(a.getAttribute('href') || '')) li.remove();
    });

    // 4. Ajouter les liens manquants
    var existingHrefs = Array.from(ul.querySelectorAll('a')).map(function (a) { return a.getAttribute('href'); });
    required.forEach(function (link) {
      if (existingHrefs.indexOf(link.href) === -1) {
        var li = document.createElement('li');
        li.innerHTML = '<small class="copyright__content"><a href="' + link.href + '">' + link.label + '</a></small>';
        ul.appendChild(li);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixFooter);
  } else {
    fixFooter();
  }
})();

/* Orbe Paris — Nuancier tissus (section nuancier-orbe-v14)
   Progressive enhancement : sans ce script, le nuancier reste OUVERT et
   utilisable (couverture masquée, les deux plaquettes dépliées).
   Avec : couverture animée sur desktop, bascule entre les deux plaquettes
   superposées sur mobile, sélection d'une teinte (met à jour le CTA).
   Scope par section + shopify:section:load (Theme Editor), garde anti-double-init. */
(function () {
  function initNuancier(root) {
    if (!root || root.dataset.nuancierReady === '1') return;
    root.dataset.nuancierReady = '1';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var animOn = root.getAttribute('data-anim') !== '0';
    var accentOn = root.getAttribute('data-accent') === '1';

    var cover = root.querySelector('[data-nuancier-open]');
    var spread = root.querySelector('[data-nuancier-spread]');
    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-nuancier-swatch]'));
    var plaques = Array.prototype.slice.call(root.querySelectorAll('[data-plaque]'));
    var mainCta = root.querySelector('[data-nuancier-main-cta]');

    root.classList.add('is-enhanced');
    if (!animOn || reduce) root.classList.add('orbe-nuancier--instant');

    function setInert(on) {
      if (!spread) return;
      if ('inert' in spread) spread.inert = on;
      spread.setAttribute('aria-hidden', on ? 'true' : 'false');
    }
    function openBook(focusInside) {
      root.classList.add('is-open');
      setInert(false);
      if (focusInside) {
        var a = root.querySelector('[data-nuancier-swatch].is-active') || swatches[0];
        if (a) a.focus({ preventScroll: true });
      }
      if (cover) { cover.setAttribute('aria-expanded', 'true'); cover.setAttribute('aria-hidden', 'true'); cover.tabIndex = -1; }
    }

    // Desktop : carnet fermé à l'arrivée, s'ouvre au clic. Mobile : ouvert d'emblée.
    var smallScreen = window.matchMedia && window.matchMedia('(max-width: 859px)').matches;
    if (cover && !smallScreen) {
      root.classList.remove('is-open');
      setInert(true);
      cover.setAttribute('aria-expanded', 'false');
      cover.addEventListener('click', function () { openBook(true); });
    } else {
      openBook(false);
    }

    // --- Pile de deux cartes (mobile) : celle de devant est en position, celle
    // du dessous dépasse à droite par sa tranche ; on tape la tranche pour la
    // ramener devant. Sur desktop les deux forment la double page du carnet et
    // la tranche est masquée en CSS. ---
    var mqStack = window.matchMedia ? window.matchMedia('(max-width: 859px)') : null;

    // Les cartes sont en position absolue dans la pile. Elles doivent faire
    // EXACTEMENT la même taille (demande fondateur) même si l'une a moins de
    // teintes : on mesure la plus haute et on l'applique aux deux.
    var measuring = false;
    function syncStackHeight() {
      if (!spread || measuring) return;
      if (mqStack && !mqStack.matches) {
        spread.style.height = '';
        plaques.forEach(function (p) { p.style.height = ''; });
        return;
      }
      measuring = true;
      plaques.forEach(function (p) { p.style.height = 'auto'; });
      var h = 0;
      plaques.forEach(function (p) { if (p.offsetHeight > h) h = p.offsetHeight; });
      plaques.forEach(function (p) { p.style.height = h + 'px'; });
      spread.style.height = h + 'px';
      measuring = false;
    }

    function openPlaque(plaque) {
      plaques.forEach(function (p) {
        p.classList.toggle('is-open', p === plaque);
      });
      // Le CTA doit parler du tissu qu'on regarde : si aucune teinte de cette
      // carte n'est sélectionnée, on prend la première.
      if (!plaque.querySelector('[data-nuancier-swatch].is-active')) {
        var first = plaque.querySelector('[data-nuancier-swatch]');
        if (first) select(first);
      }
      syncStackHeight();
    }

    plaques.forEach(function (p) {
      var tab = p.querySelector('[data-plaque-toggle]');
      if (!tab) return;
      tab.addEventListener('click', function () {
        if (!p.classList.contains('is-open')) openPlaque(p);
      });
    });

    syncStackHeight();
    window.addEventListener('resize', syncStackHeight);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(syncStackHeight);
      plaques.forEach(function (p) { ro.observe(p); });
    }

    function applyAccent(btn) {
      if (!accentOn) return;
      var a = btn.getAttribute('data-accent');
      if (a) root.style.setProperty('--nuancier-accent', a);
    }

    function setMainCta(btn) {
      if (!mainCta) return;
      // Override « bientôt disponible » (tissu sans produits) : texte fixe + lien neutralisé.
      var override = btn.getAttribute('data-cta-text');
      if (override) {
        mainCta.textContent = override;
        mainCta.removeAttribute('href');
        mainCta.setAttribute('aria-disabled', 'true');
        mainCta.classList.add('is-disabled');
        return;
      }
      mainCta.removeAttribute('aria-disabled');
      mainCta.classList.remove('is-disabled');
      var name = btn.getAttribute('data-name') || '';
      var tpl = mainCta.getAttribute('data-template') || 'Voir les modèles en {teinte}';
      mainCta.textContent = tpl.indexOf('{teinte}') !== -1 ? tpl.replace('{teinte}', name) : tpl;
      var link = btn.getAttribute('data-cta-link') || mainCta.getAttribute('data-default-link') || '#';
      mainCta.setAttribute('href', link);
    }

    function select(btn) {
      if (btn.getAttribute('aria-pressed') === 'true') return; // déjà active
      swatches.forEach(function (s) {
        var on = s === btn;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      applyAccent(btn);
      setMainCta(btn);
    }

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () { select(btn); });
    });

    var initActive = root.querySelector('[data-nuancier-swatch].is-active') || swatches[0];
    if (initActive) { applyAccent(initActive); setMainCta(initActive); }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-nuancier]').forEach(initNuancier);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initAll(e.target);
  });
})();

/* Orbe Paris — Nuancier v15 (section nuancier-orbe-v15)
   Deux choses seulement : basculer d'un tissu à l'autre (onglets) et changer la
   teinte affichée (visuel du fauteuil + médaillon macro + nom + phrase + CTA).
   L'état initial est déjà rendu côté serveur : sans ce script, les deux
   panneaux restent dépliés et la 1re teinte de chacun est visible.
   Le fondu croisé se fait sur deux calques <img>, la nouvelle image étant
   préchargée avant l'échange pour ne jamais montrer de trou blanc. */
(function () {
  function initPanel(panel) {
    var heroA = panel.querySelector('[data-hero-a]');
    var heroB = panel.querySelector('[data-hero-b]');
    var macro = panel.querySelector('[data-macro]');
    var nameOut = panel.querySelector('[data-name-out]');
    var phraseOut = panel.querySelector('[data-phrase-out]');
    var cta = panel.querySelector('[data-main-cta]');
    var soon = panel.querySelector('[data-main-soon]');
    var swatches = Array.prototype.slice.call(panel.querySelectorAll('[data-swatch]'));
    if (!swatches.length) return;

    function setHero(src, alt) {
      if (!heroA || !heroB || !src) return;
      var visible = heroA.classList.contains('is-on') ? heroA : heroB;
      var hidden = visible === heroA ? heroB : heroA;
      if (visible.getAttribute('src') === src) {
        visible.alt = alt || '';
        return;
      }
      // Préchargement, puis décodage du calque caché AVANT de l'afficher : sans
      // ça, l'échange peut se faire sur une image pas encore peinte (trou blanc).
      var pre = new Image();
      pre.onload = function () {
        hidden.src = src;
        hidden.alt = alt || '';
        var swap = function () {
          hidden.removeAttribute('aria-hidden');
          visible.alt = '';
          visible.setAttribute('aria-hidden', 'true');
          hidden.classList.add('is-on');
          visible.classList.remove('is-on');
        };
        if (hidden.decode) hidden.decode().then(swap, swap);
        else swap();
      };
      pre.src = src;
    }

    // 2026-08-08 : la maille bouclette mélange des coloris en vente et des
    // coloris pas encore commandables (data-cta-text sur la pastille). Le CTA
    // et la mention « bientôt disponible » sont tous deux dans le DOM, on
    // bascule de l'un à l'autre — sans ça, un coloris sans fiche affichait
    // « Voir le fauteuil en … » pointant vers le catalogue.
    function setCta(btn) {
      var soonText = btn.getAttribute('data-cta-text');
      if (soon) {
        if (soonText) soon.textContent = soonText;
        soon.hidden = !soonText;
      }
      if (!cta) return;
      cta.hidden = !!soonText;
      if (soonText) return;
      // `data-cta-label` (2026-08-08) : libellé calculé côté Liquid, prioritaire
      // sur le gabarit. Il nomme la pièce réellement liée — le fauteuil en règle
      // générale, le pouf pour les coloris qui n'existent que dans ce modèle.
      var label = btn.getAttribute('data-cta-label');
      var name = btn.getAttribute('data-name') || '';
      var tpl = cta.getAttribute('data-template') || '';
      if (label) cta.textContent = label;
      else if (tpl) cta.textContent = tpl.indexOf('{teinte}') !== -1 ? tpl.replace('{teinte}', name) : tpl;
      cta.setAttribute('href', btn.getAttribute('data-link') || cta.getAttribute('data-default-link') || '#');
    }

    function select(btn) {
      if (btn.getAttribute('aria-pressed') === 'true') return;
      swatches.forEach(function (s) {
        var on = s === btn;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      setHero(btn.getAttribute('data-hero'), btn.getAttribute('data-alt'));
      if (macro && btn.getAttribute('data-macro')) macro.src = btn.getAttribute('data-macro');
      if (nameOut) nameOut.textContent = btn.getAttribute('data-name') || '';
      if (phraseOut) phraseOut.textContent = btn.getAttribute('data-phrase') || '';
      setCta(btn);
    }

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () { select(btn); });
    });
  }

  function initNuancier15(root) {
    if (!root || root.dataset.n15Ready === '1') return;
    root.dataset.n15Ready = '1';
    root.classList.add('is-enhanced');

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));
    var tabsRow = root.querySelector('[data-tabs]');
    var panelsWrap = root.querySelector('.orbe-nuancier15__panels');

    // Hauteur du conteneur = hauteur du panneau actif, transitionnée en CSS.
    // Sans ça, les deux panneaux empilés imposent la hauteur du plus grand et
    // le tissu le plus court traîne un grand vide sous lui.
    function syncHeight() {
      if (!panelsWrap) return;
      var on = root.querySelector('[data-panel].is-on');
      if (on) panelsWrap.style.height = on.getBoundingClientRect().height + 'px';
    }

    // Le filet sous les onglets est un seul trait : on lui donne la position et
    // la largeur de l'onglet actif, le CSS fait le glissement. offsetLeft est
    // relatif à la rangée (position: relative), et offsetTop gère le cas où les
    // deux libellés passent à la ligne sur un écran très étroit.
    function moveBar(tab) {
      if (!tabsRow || !tab) return;
      tabsRow.style.setProperty('--n15-bar-x', tab.offsetLeft + 'px');
      tabsRow.style.setProperty('--n15-bar-w', tab.offsetWidth + 'px');
      tabsRow.style.setProperty('--n15-bar-y', (tab.offsetTop + tab.offsetHeight) + 'px');
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-on', p.getAttribute('data-panel') === key);
        });
        moveBar(tab);
        syncHeight();
      });
    });

    // Arrivée depuis une fiche produit (2026-08-07) : le lien « Voir le tissu
    // de près » porte `?tissu=teddy` ou `?tissu=3d` et doit ouvrir le bon
    // onglet. Liquid n'a aucun accès aux paramètres d'URL (choix Shopify lié au
    // cache CDN), la sélection se fait donc ici, côté navigateur.
    var voulu = null;
    try {
      voulu = new URLSearchParams(window.location.search).get('tissu');
    } catch (e) { /* navigateur sans URLSearchParams : on garde l'onglet par défaut */ }
    if (voulu) {
      var cible = tabs.filter(function (t) { return t.getAttribute('data-tab') === voulu; })[0];
      if (cible && !cible.classList.contains('is-on')) cible.click();
    }

    function refresh() {
      moveBar(root.querySelector('[data-tab].is-on') || tabs[0]);
      syncHeight();
    }

    refresh();
    // Les polices web décalent la largeur des libellés et la hauteur des panneaux
    // après coup ; on remesure aussi à chaque changement de taille du contenu.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
    window.addEventListener('resize', refresh);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(syncHeight);
      panels.forEach(function (p) { ro.observe(p); });
    }

    panels.forEach(initPanel);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-nuancier15]').forEach(initNuancier15);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initAll(e.target);
  });
})();
